export const GET_DETAIL_SELLER_PENDING = "GET_DETAIL_SELLER_PENDING";
export const GET_DETAIL_SELLER_SUCCESS = "GET_DETAIL_SELLER_SUCCESS";
export const GET_DETAIL_SELLER_FAILED = "GET_DETAIL_SELLER_FAILED";
